import { useNavigate } from "react-router-dom";

const UserAccountinstantsNavigation = (userId) => {
  const navigate = useNavigate();

  const goToUserAccountInstants = () => {
    navigate(`/user-instants/${userId}`); // Ensure this route exists in your app
  };

  return { goToUserAccountInstants }; // ✅ Return an object
};

export default UserAccountinstantsNavigation;